"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
/**
 * <h4>Customer configuration class<h4/>
 *
 * You need to set variable `customerSymbol` and variable `host` to be able to use Quarticon recommendation frames.
 *
 * If you do not know where to get the customer's symbol, please contact our technical support.
 *
 * ```typescript
 * const customerConfiguration = new Config({customerSymbol: _CUSTOMER_SYMBOL_, host: _HOST_})
 * ```
 */
var Config = /** @class */ (function () {
    /**
     * @param configParams Customer configuration parameters
     * @returns Main configuration element
     */
    function Config(configParams) {
        var _this = this;
        /** @ignore */
        this.getHost = function () {
            return _this.host;
        };
        /** @ignore */
        this.getCustomer = function () {
            return _this.customerSymbol;
        };
        /** @ignore */
        this.getBaseUrl = function () {
            return "qon.".concat(_this.host);
        };
        /** @ignore */
        this.getCookie = function () {
            return _this.cookie;
        };
        this.customerSymbol = configParams.customerSymbol;
        this.host = configParams.host;
        this.cookie = configParams.cookie;
    }
    return Config;
}());
exports.Config = Config;
//# sourceMappingURL=Config.js.map